module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "form",
    attrs: {
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('wi-save', {
    attrs: {
      "slot": "header",
      "form": ['mainForm', 'expenseForm'],
      "title": _vm.$t('MANAGEBUS'),
      "data": {
        bus: this.bus
      }
    },
    slot: "header"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-tabs', {
    staticClass: "tabs",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-form', {
    ref: "mainForm",
    attrs: {
      "model": _vm.bus,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('BUSNUMBER'),
      "prop": "Label",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Label),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Label", $$v)
      },
      expression: "bus.Label"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('REGISTRATIONEXPIRATIONDATE'),
      "prop": "RegistrationExpiration",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('PICKADATE'),
      "format": _vm.date_format,
      "picker-options": _vm.pickerOption
    },
    model: {
      value: (_vm.bus.RegistrationExpiration),
      callback: function($$v) {
        _vm.$set(_vm.bus, "RegistrationExpiration", $$v)
      },
      expression: "bus.RegistrationExpiration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('PLATENUMBER'),
      "prop": "Plate",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Plate),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Plate", $$v)
      },
      expression: "bus.Plate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SEATINGCAPACITY'),
      "prop": "MaxSeats",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.MaxSeats),
      callback: function($$v) {
        _vm.$set(_vm.bus, "MaxSeats", $$v)
      },
      expression: "bus.MaxSeats"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MODEL'),
      "prop": "Model",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Model),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Model", $$v)
      },
      expression: "bus.Model"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('YEAR'),
      "prop": "Year",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "year",
      "placeholder": _vm.$t('PICKAYEAR'),
      "picker-options": _vm.yearDisable
    },
    model: {
      value: (_vm.bus.Year),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Year", $$v)
      },
      expression: "bus.Year"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('MAKE'),
      "prop": "Make",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bus.Make),
      callback: function($$v) {
        _vm.$set(_vm.bus, "Make", $$v)
      },
      expression: "bus.Make"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.getTabData
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('EXPENSES')
    }
  }, [_c('el-form', {
    ref: "expenseForm",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "model": _vm.bus,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEPRICE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Price",
      "rules": {
        type: 'string',
        required: false,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    on: {
      "change": function($event) {
        _vm.priceVal = (_vm.bus.Expenses.Price !== '')
      }
    },
    model: {
      value: (_vm.bus.Expenses.Price),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Price", $$v)
      },
      expression: "bus.Expenses.Price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEPERMIT') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Permit",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Permit),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Permit", $$v)
      },
      expression: "bus.Expenses.Permit"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('REGISTRATION') + ' ' + _vm.$t('COST') + ' ' + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Registration",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Registration),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Registration", $$v)
      },
      expression: "bus.Expenses.Registration"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INSURANCE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Insurance",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Insurance),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Insurance", $$v)
      },
      expression: "bus.Expenses.Insurance"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('INSPECTION') + ' ' + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Inspection",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Inspection),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Inspection", $$v)
      },
      expression: "bus.Expenses.Inspection"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Year")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('VEHICLEDEPRECIATION'),
      "prop": "Expenses.Depreciation",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Depreciation),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Depreciation", $$v)
      },
      expression: "bus.Expenses.Depreciation"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ %")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DRIVER') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Driver",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Driver),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Driver", $$v)
      },
      expression: "bus.Expenses.Driver"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SUPERVISOR') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Supervisor",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Supervisor),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Supervisor", $$v)
      },
      expression: "bus.Expenses.Supervisor"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('FINANCIAL') + ' ' + _vm.$t('COST') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Finance",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Finance),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Finance", $$v)
      },
      expression: "bus.Expenses.Finance"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Month")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('WEARTEAR') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Wear_Tear",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Wear_Tear),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Wear_Tear", $$v)
      },
      expression: "bus.Expenses.Wear_Tear"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('GASRATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Fuel",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Fuel),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Fuel", $$v)
      },
      expression: "bus.Expenses.Fuel"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('OILRATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Oil",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Oil),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Oil", $$v)
      },
      expression: "bus.Expenses.Oil"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('TIRERATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Tire",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Tire),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Tire", $$v)
      },
      expression: "bus.Expenses.Tire"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Km")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('IDLERATE') + ' ' + _vm.$t('INAED'),
      "prop": "Expenses.Idling",
      "rules": {
        type: 'string',
        required: _vm.priceVal,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('ENTERRATE')
    },
    model: {
      value: (_vm.bus.Expenses.Idling),
      callback: function($$v) {
        _vm.$set(_vm.bus.Expenses, "Idling", $$v)
      },
      expression: "bus.Expenses.Idling"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("/ Min")])], 2)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('DOCUMENTS')
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-docs",
    attrs: {
      "drag": "",
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploaded,
      "data": {
        folder: 'bus'
      },
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "action": _vm.URL + 'media/upload/documents',
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('DROPFILEHEREOR')) + " "), _c('em', [_vm._v(_vm._s(_vm.$t('CLICKTOUPLOAD')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('JPGPNGFILES')))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.bus.Documents,
      "height": _vm.cardHeight - 118
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-select', {
          staticClass: "form-control",
          attrs: {
            "title": _vm.$t('DOCUMENTTYPE')
          },
          model: {
            value: (props.row.label),
            callback: function($$v) {
              _vm.$set(props.row, "label", $$v)
            },
            expression: "props.row.label"
          }
        }, [_c('el-option', {
          attrs: {
            "label": _vm.$t('REGISTRATION'),
            "value": "Registration"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('INSURANCE'),
            "value": "Insurance"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('OTHER'),
            "value": ""
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file_name",
      "label": _vm.$t('File')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('PREVIEW'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.openSlider(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sticky-note"
        }), _vm._v(" " + _vm._s(_vm.$t('VIEW')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('DELETEDOCUMENT'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              props.row.deleted = !props.row.deleted
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-2x",
          class: [props.row.deleted ? 'fa-undo' : 'fa-remove']
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-doc-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "document": _vm.document
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.bus.BusID != null) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('ROUTES'),
      "name": "route"
    }
  }, [_c('el-row', {
    staticClass: "tab-table-margin"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingRoutes),
      expression: "loadingRoutes"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.routes,
      "highlight-current-row": "",
      "height": _vm.cardHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "left",
    attrs: {
      "label": _vm.$t('NAME'),
      "show-overflow-tooltip": "",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "display": "block",
            "text-align": "center"
          },
          style: ('background-color:' + scope.row.RouteColor)
        }, [_c('el-button', {
          staticStyle: {
            "color": "#fff",
            "padding": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_vm._v(_vm._s(scope.row.TourName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('DRIVER'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.DriverPhoto, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.DriverFullName_EN,
          NameAR: scope.row.DriverFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('SUPERVISOR'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.MonitorPhoto, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.MonitorFullName_EN,
          NameAR: scope.row.MonitorFullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "40",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITROUTE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/transportation/route/' + scope.row.TourID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('VIOLATIONS')
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATIONS')))]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65526748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transportation/BusManage.vue
// module id = 606
// module chunks = 1